import React, { useEffect } from "react";
import "./OurProject.css";

import AOS from "aos";
import "aos/dist/aos.css";

const OurProject = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div className="container-fluid ourProject-container ">
      <div className="container py-3 ">
        <div className="row g-5 align-items-center">
          <div
            className="col-12 col-md-6 "
          // data-aos="fade-up"
          >
            <p className="mb-3 ourProject-title">Our Projects</p>
            <p className="mb-3 ourProject-subTitle">
              Prime Location, Promising Prosperity
            </p>
            <p className="text-left ourProject-desc">
              This venture is perfectly situated in a prime location, offering
              &nbsp;
              <span className="ourProjectSpecial">
                230 open plots ranging from 170 sq. yds to 440 sq. yds,
              </span>
              &nbsp; beautifully spread across{" "}
              <span className="ourProjectSpecial">20.8 acres. </span> Nestled
              close to the Inner Ring Road and just half a kilometer from the
              serene Krishna River, the plots are near the renowned Amaravathi
              which is the fast- developing capital city. The Amaravati temple
              is also a famous pilgrimage centre. Additionally, the proximity to
              the upcoming Film City, Iconic Bridge, Sports City and
              Vaikuntapuram enhances the appeal of this investment, combining
              spiritual and modern attractions in one ideal setting.
            </p>
          </div>

          <div
            className="col-12 col-md-6 text-center text-md-left mb-4 mb-md-0"
          // data-aos="fade-down"
          >
            <img
              src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2Fd05274657b324049916f3b22b0ceedeb`}
              alt="our-Project"
              className="img-fluid ourProjectImg"
              style={{ filter: "brightness(1.2)" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurProject;
